import { connectMediaStore } from './withOwnReduxStore';
import { getFlags } from '../../redux/flags/selectors';
export default connectMediaStore((state)=>({
        flags: Object.keys(getFlags(state))
    }), {});
